module.exports = __webpack_public_path__ + "media/Video 49b.e6947b1b.mp4";